import { applyMiddleware, combineReducers, createStore } from 'redux';
import { createLogicMiddleware } from 'redux-logic';

import { authReducers, ReduxLogic } from 'common/auth/auth_context';
import { deviceHandoffLogic } from 'common/deviceHandoff/effects/orchestrator';
import { deviceHandoffReducer } from 'common/deviceHandoff/state/reducer';

// Root Redux store: combines reducers and registers redux-logic middleware.
export const store = createStore(
    combineReducers({
        auth: authReducers,
        deviceHandoff: deviceHandoffReducer,
    }),
    applyMiddleware(createLogicMiddleware([...ReduxLogic, ...deviceHandoffLogic]))
);

export type RootState = ReturnType<typeof store.getState>;
